/** Предложение ярлыка на экран телефона — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { registerWindow } from "../../../app";
import { HomeScreenView } from "./view";
import { actions } from "../actions";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    homeScreen: object;
  }
}

export function HomeScreen({ close }: WindowProps<"homeScreen">) {
  const answer = (add: boolean): void => {
    actions().answerHomeScreen(add);
    close();
  };
  return <HomeScreenView onAdd={() => answer(true)} onDecline={() => answer(false)} />;
}

export function register(): void {
  registerWindow("homeScreen", HomeScreen);
}
